import { Colors, Language, Lightning, Router, Log } from '@lightningjs/sdk'
import IconButton from '../components/buttons/IconButton'
import Slider from '../components/grid/Slider'
import Strip from '../components/grid/Strip'

export default class Podcasts extends Lightning.Component {
  static _template() {
    return {
      w: 1920,
      h: 1080,
      rect: true,
      color: Colors('PageBG').get(),
      Header: {
        w: 1920,
        h: 180,
        rect: true,
        color: Colors('PageBG').get(),
        zIndex: 10,
        Title: {
          x: 260,
          y: 62,
          w: 1450,
          h: 75,
          color: Colors('white').get(),
          text: {
            text: Language.translate('PodcastTitle'),
            textAlign: 'left',
            fontSize: 55,
            fontFace: 'OpenSansBold',
            lineHeight: 75,
          },
        },
        SearchButn: {
          x: 1646,
          y: 62,
          w: 200,
          h: 60,
          type: IconButton,
          padding: 38,
          buttonText: Language.translate('Search').toUpperCase(),
          buttonType: 'search',
        },
      },
      PodcastGrid: {
        w: 1660,
        h: 895,
        x: 260,
        y: 183,
        type: Slider,
        scrollOffsetStart: 0,
        scrollOffsetEnd: 621,
        spacing: 0,
        signals: { filled: true, requestMoreItems: true, changeRowIndex: true },
      },
    }
  }

  set items(data) {
    this._dataSet = data
    this._items = data.blocks

    if (data) {
      this._buildSliders()
    } else {
      this.noData = true
    }

    this._setState('Idle')
  }

  _init() {
    this.widgets['sidemenu'].activeMenuItem = 3

    this._setState('Idle')
  }
  historyState(params) {
    if (params) {
      if (params.mainIndex) {
        this.tag('PodcastGrid').index = params.mainIndex
      }
      if (params.crossIndex) {
        this.tag('PodcastGrid').items[this.tag('PodcastGrid').index].sliderIndex = params.crossIndex
      }
    } else {
      return {
        mainIndex: this.tag('PodcastGrid').index,
        crossIndex: this.tag('PodcastGrid').items[this.tag('PodcastGrid').index].sliderIndex,
      }
    }
  }

  _focus() {
    this._setState('PodcastGrid')
  }
  _inactive() {
    this.stage.gc()
  }

  _buildSliders() {
    const gridRows = this._items.map(row => {
      let gridRow = {
        data: [],
        title: row.title,
        type: row.type || 'podcast',
      }

      gridRow.data = row.podcasts.map(rowItem => {
        return { item: rowItem }
      })

      return gridRow
    })

    if (gridRows) {
      this.noData = false

      this.tag('PodcastGrid').items = gridRows.map((collection, idx) => {
        return {
          ref: `SliderRow-${idx}`,
          h: 621,
          w: 1660,
          type: Strip,
          index: idx,
          items: collection,
          coverType: 'podcast',
          signals: { filled: 'stripFilled' },
        }
      })
    }
  }
  playbackError() {
    this.widgets.errorbox.alpha = 1
    this.widgets.errorbox.notify({ type: 'playbackStopped', Notification: true })
    Router.focusWidget('ErrorBox')
  }

  static _states() {
    return [
      class Idle extends this {
        filled() {
          this._setState('PodcastGrid')
        }

        stripFilled() {
          this._setState('PodcastGrid')
        }
      },

      class PodcastGrid extends this {
        $enter() {
          this._currRow = this.tag('PodcastGrid').index
        }

        _handleBack() {
          Log.info('Podcasts:HandleBack')
          if (this.tag('PodcastGrid').index > 0) {
            this.tag('PodcastGrid').index = 0
          } else {
            Router.focusWidget('SideMenu')
          }
        }

        _handleLeft() {
          Router.focusWidget('SideMenu')
        }

        _handleEnter() {
          if (
            this.tag('PodcastGrid').currentRow &&
            this.tag('PodcastGrid').currentRow.listCurrentItem
          ) {
            Router.navigate(`podcastDetails/${this.tag('PodcastGrid').currentCellItem.item.linkId}`)
          }
        }

        _handleUp() {
          this._setState('Search')
        }

        _getFocused() {
          return this.tag('PodcastGrid')
        }
      },

      class Search extends this {
        _handleLeft() {
          Router.focusWidget('SideMenu')
        }

        _handleDown() {
          this._setState('PodcastGrid')
        }

        _handleEnter() {
          Router.navigate('search')
        }

        _getFocused() {
          return this.tag('SearchButn')
        }
      },
    ]
  }
}
